import State from 'store/State';
import { selectStreamedDataState } from 'streamsState/store/streamedData/selectors';
import { buildStreamedDataStreamSlice } from 'streamsState/store/streamedData/streamSlice';

import {
    createFillsGraphStreamRequestBySymbolRequestUid,
    FillsGraphStreamedDataStreamState,
    initialFillsGraphStreamedDataStreamState,
    toFillsGraphStreamRequestBySymbolRequestUid,
} from './FillsGraphStreamedDataHelpers';
import { initialFillsGraphDataState } from 'widgets/fillsGraph/store/data/FillsGraphDataState';
import { FillsGraphElement } from 'communication/types/fillsGraph/FillsGraphElement';
import { processFillsGraphDataStreamElement } from 'widgets/fillsGraph/store/data/reducer';

const processDataStreamElement = (
    element: FillsGraphElement,
    nextState: FillsGraphStreamedDataStreamState
) => {
    const nextDataState = nextState.data ?? { ...initialFillsGraphDataState };
    processFillsGraphDataStreamElement(element, nextDataState, nextState);
};

export const selectFillsGraphStreamRequestBySymbolStreamedData = (
    state: State
) => selectStreamedDataState(state).fillsGraphStreamRequestBySymbol;

const buildPerfVsIndexCapsuleStreamSlice = () =>
    buildStreamedDataStreamSlice(
        'startFillsGraphByOrderIdOrSymQtyStream',
        initialFillsGraphStreamedDataStreamState,
        selectFillsGraphStreamRequestBySymbolStreamedData,
        createFillsGraphStreamRequestBySymbolRequestUid,
        toFillsGraphStreamRequestBySymbolRequestUid,
        processDataStreamElement
    );

const { reducer: fillsGraphStreamedDataReducer } =
    buildPerfVsIndexCapsuleStreamSlice();

export { fillsGraphStreamedDataReducer };
